"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNDERLYINGS_TO_PUBKEY_MAP = exports.PUBKEY_TO_UNDERLYINGS_MAP = exports.SOL_DECIMALS = exports.SOL_PUBKEY = exports.PYTH_PRICE_FEEDS = void 0;
const web3_js_1 = require("@solana/web3.js");
exports.PYTH_PRICE_FEEDS = {
    localnet: {
        "SOL/USD": new web3_js_1.PublicKey("2pRCJksgaoKRMqBfa7NTdd6tLYe9wbDFGCcCCZ6si3F7"),
    },
    devnet: {
        "SOL/USD": new web3_js_1.PublicKey("J83w4HKfqxwcq3BEMMkPFSppX3gqekLyLJBexebFVkix"),
        "RAY/USD": new web3_js_1.PublicKey("EhgAdTrgxi4ZoVZLQx1n93vULucPpiFi2BQtz9RJr1y6"),
        "MER/USD": new web3_js_1.PublicKey("6Z3ejn8DCWQFBuAcw29d3A5jgahEpmycn7YDMX7yRNrn"),
        "SBR/USD": new web3_js_1.PublicKey("4WSN3XDSTfBX9A1YXGg8HJ7n2GtWMDNbtz1ab6aGGXfG"),
        "BTC/USD": new web3_js_1.PublicKey("HovQMDrbAgAYPCmHVSrezcSmkMtXSSUsLDFANExrZh2J"),
        "MSOL/USD": new web3_js_1.PublicKey("9a6RNx3tCu1TSs6TBSfV2XRXEPEZXQ6WB7jRojZRvyeZ"),
        "STSOL/USD": new web3_js_1.PublicKey("2LwhbcswZekofMNRtDRMukZJNSRUiKYMFbqtBwqjDfke"),
        "SRM/USD": new web3_js_1.PublicKey("992moaMQKs32GKZ9dxi8keyM2bUmbrwBZpK4p2K6X5Vs"),
        "USDC/USD": new web3_js_1.PublicKey("5SSkXsEKQepHHAewytPVwdej4epN1nxgLVM84L4KXgy7"),
        "USDT/USD": new web3_js_1.PublicKey("C5wDxND9E61RZ1wZhaSTWkoA8udumaHnoQY6BBsiaVpn"),
    },
    mainnet: {
        "SOL/USD": new web3_js_1.PublicKey("H6ARHf6YXhGYeQfUzQNGk6rDNnLBQKrenN712K4AQJEG"),
        "MSOL/USD": new web3_js_1.PublicKey("E4v1BBgoso9s64TQvmyownAVJbhbEPGyzA3qn4n46qj9"),
        "STSOL/USD": new web3_js_1.PublicKey("Bt1hEbY62aMriY1SyQqbeZbm8VmSbQVGBFzSzMuVNWzN"),
        "SRM/USD": new web3_js_1.PublicKey("3NBReDRTLKMQEKiLD5tGcx4kXbTf88b7f2xLS9UuGjym"),
        "BTC/USD": new web3_js_1.PublicKey("GVXRSBjFk6e6J3NbVPXohDJetcTjaeeuykUpbQF8UoMU"),
        "ETH/USD": new web3_js_1.PublicKey("JBu1AL4obBcCMqKBBxhpWCNUt136ijcuMZLFvTP7iWdB"),
        "LUNA/USD": new web3_js_1.PublicKey("5bmWuR1dgP4avtGYMNKLuxumZTVKGgoN2BCMXWDNL9nY"),
        "MNGO/USD": new web3_js_1.PublicKey("79wm3jjcPr6RaNQ4DGvP5KxG1mNd3gEBsg6FsNVFezK4"),
        "FTT/USD": new web3_js_1.PublicKey("8JPJJkmDScpcNmBRKGZuPuG2GYAveQgP3t5gFuMymwvF"),
        "RAY/USD": new web3_js_1.PublicKey("AnLf8tVYCM816gmBjiy8n53eXKKEDydT5piYjjQDPgTB"),
        "SNY/USD": new web3_js_1.PublicKey("BkN8hYgRjhyH5WNBQfDV73ivvdqNKfonCMhiYVJ1D9n9"),
        "USDC/USD": new web3_js_1.PublicKey("Gnt27xtC473ZT2Mw5u8wZ68Z3gULkSTb5DuxJy7eJotD"),
        "USDT/USD": new web3_js_1.PublicKey("3vxLXJqLqF3JG5TCbYycbKWRBbCJQLxQmBGCkyqEEefL"),
        "WINJ/USD": new web3_js_1.PublicKey("9EdtbaivHQYA4Nh3XzGR6DwRaoorqXYnmpfsnFhvwuVj"),
        "SCNSOL/USD": new web3_js_1.PublicKey("25yGzWV5okF7aLivSCE4xnjVUPowQcThhhx5Q2fgFhkm"),
        "SLRS/USD": web3_js_1.PublicKey.default,
        "AAVE/USD": new web3_js_1.PublicKey("3wDLxH34Yz8tGjwHszQ2MfzHwRoaQgKA32uq2bRpjJBW"),
        "ALGO/USD": new web3_js_1.PublicKey("HqFyq1wh1xKvL7KDqqT7NJeSPdAqsDqnmBisUC2XdXAX"),
        "ATLAS/USD": new web3_js_1.PublicKey("81Rz3i7MC9nHYo1vQg6kJM5hepjqb63Y1gnr3AkrD36D"),
        "AVAX/USD": new web3_js_1.PublicKey("Ax9ujW5B9oqcv59N8m6f1BpTBq2rGeGaBcpKjC5UYsXU"),
        "BNB/USD": new web3_js_1.PublicKey("4CkQJBxhU8EZ2UjhigbtdaPbpTe6mqf811fipYBFbSYN"),
        "BRZ/USD": new web3_js_1.PublicKey("2wrWGm63xWubz7ue4iYR3qvBbaUJhZVi4eSpNuU8k8iF"),
        "C98/USD": new web3_js_1.PublicKey("45rTB9ezDcTX5tMZx2uJUBbBEqAWDhXykYbBfaSWUXvD"),
        "DOT/USD": new web3_js_1.PublicKey("EcV1X1gY2yb4KXxjVQtTHTbioum2gvmPnFk4zYAt7zne"),
        "FIDA/USD": new web3_js_1.PublicKey("ETp9eKXVv1dWwHSpsXRUuXHmw24PwRkttCGVgpZEY9zF"),
        "FTM/USD": new web3_js_1.PublicKey("7Dn52EY5EGE8Nvvw98KVMGPWTiTGn3PF4y24TVLyXdT9"),
        "GOFX/USD": new web3_js_1.PublicKey("7UYk5yhrQtFbZV2bLX1gtqN7QdU9xpBMyAk7tFgoTatk"),
        "HXRO/USD": new web3_js_1.PublicKey("B47CC1ULLw1jKTSsr1N1198zrUHp3LPduzepJyzgLn2g"),
        "JET/USD": new web3_js_1.PublicKey("9j2xgDVWMY4WZXSj4AL4asCBtzCXz8jqRcDMbcVeZgNU"),
        "MATIC/USD": new web3_js_1.PublicKey("7KVswB9vkCgeM3SHP7aGDijvdRAHK8P5wi9JXViCrtYh"),
        "MER/USD": new web3_js_1.PublicKey("G4AQpTYKH1Fmg38VpFQbv6uKYQMpRhJzNPALhp7hqdrs"),
        "NEAR/USD": new web3_js_1.PublicKey("ECSFWQ1bnnpqPVvoy9237t2wddZAaHisW88mYxuEHKWf"),
        "ORCA/USD": new web3_js_1.PublicKey("4ivThkX8uRxBpHsdWSqyXYihzKF3zpRGAUCqyuagnLoV"),
        "PORT/USD": new web3_js_1.PublicKey("jrMH4afMEodMqirQ7P89q5bGNJxD8uceELcsZaVBDeh"),
        "SBR/USD": new web3_js_1.PublicKey("8Td9VML1nHxQK6M8VVyzsHo32D7VBk72jSpa9U861z2A"),
        "SLND/USD": new web3_js_1.PublicKey("HkGEau5xY1e8REXUFbwvWWvyJGywkgiAZZFpryyraWqJ"),
        "ZBC/USD": new web3_js_1.PublicKey("3bNH7uDsap5nzwhCvv98i7VshjMagtx1NXTDBLbPYD66"),
    },
};
exports.SOL_PUBKEY = new web3_js_1.PublicKey("So11111111111111111111111111111111111111112");
exports.SOL_DECIMALS = 9;
exports.PUBKEY_TO_UNDERLYINGS_MAP = {
    localnet: {
        A8WuCNG5jchCkSgPqKqEZRY7wCRn9D2qHnmeQZkxbt9u: "MOCK_SRM",
        CV3KAMGe3Q8hQLEEYMJ1aJjmxDyagpVh6Gsvf2DL5URj: "MOCK_SOL",
        "5AwSyq84wsaiRyYVBdqvSvxP1zeM1sfara3ZVEAjZFB8": "MOCK_USDC",
        WCuh85EGUrW1qCv6C8FximNUwjfaaAqRwESHX7cBWY7: "MOCK_CUSDC",
    },
    devnet: {
        A8WuCNG5jchCkSgPqKqEZRY7wCRn9D2qHnmeQZkxbt9u: "MOCK_SRM",
        CV3KAMGe3Q8hQLEEYMJ1aJjmxDyagpVh6Gsvf2DL5URj: "MOCK_SOL",
        "5AwSyq84wsaiRyYVBdqvSvxP1zeM1sfara3ZVEAjZFB8": "MOCK_USDC",
        "4zMMC9srt5Ri5X14GAgXhaHii3GnPAEERYPJgZJDncDU": "USDC",
        So11111111111111111111111111111111111111112: "SOL",
        WCuh85EGUrW1qCv6C8FximNUwjfaaAqRwESHX7cBWY7: "Z_MOCK_CUSDC",
        // SOLEND COLLATERAL TOKENS
        FzwZWRMc3GCqjSrcpVX3ueJc6UpcV6iWWb7ZMsTXE3Gf: "SOLEND_CSOL",
        E2PSSXsXJGdpqhhaV3rYPpuy1inRCQAWxcdykA1DTmYr: "SOLEND_CUSDC",
        C2JUrHN3Jj4CzL1behQ8mHmswBvYGy9UcjNvvCCmEdVT: "SOLEND_CRAY",
        GVje4h3Sy8mFZgEAdpacZLq7jRLczkU9HcuAZSr6f9YM: "SOLEND_CSRM",
        Ei2dC7hFxBhVq5pn4qNJLMxKBSojx7p7wnNoBz4HELKG: "SOLEND_CMSOL",
        ACo8zUxnXNaTvjvN5S56C7KLWzCH4pXjSMU7iAg6dHj8: "SOLEND_CUSDT",
        "6G9TFs48EkWQodGHAK1fjXC8umqZBdn8Mc8bX5iUvc2j": "SOLEND_CSOFTT",
        "66F7DZxwKB4KpPy3xFMzRRzh2pLHhJ7qegBM3ejFAwg4": "SOLEND_CMER",
        "3kqx7NHrBWUD6LuWvvwzocpTVt7TDYbJ3ad7HNUPSBf6": "SOLEND_CSOETH",
        "4GAGuewTRMfBJukgu3HSzpT48iqP4bYVCq3tygnjqmxL": "SOLEND_CSBR",
        "7YaBJi5jnuadi5LZBB9NgRt1hPKhA7qQYWkzU11kgRcn": "SOLEND_CBTC",
    },
    mainnet: {
        So11111111111111111111111111111111111111112: "SOL",
        EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v: "USDC",
        Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB: "USDT",
        mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So: "MSOL",
        "7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj": "STSOL",
        SRMuApVNdxXokk5GT7XD5cUUgXMBCoAz2LHeuAoKWRt: "SRM",
        "2FPyTwcZLUg1MDrwsyoP4D6s1tM7hAkHYRjkNb5w6Pxk": "ETH",
        "7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs": "ETHPO",
        "9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E": "BTC",
        F6v4wfAdJB8D8p77bMXZgYt8TDKsYxLYxH5AFhUkYx9W: "LUNA",
        MangoCzJ36AjZyKwVj3VnYU4GTonjfVEnJmvvWaxLac: "MNGO",
        AGFEad2et2ZJif9jaGpdMixQqvW5i81aBdvKe7PHNfz3: "FTT",
        "4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R": "RAY",
        Hgtvu9gsDTzUpBn69WjrhMyzaQhrAM9piTsezmZVQP6Z: "WINJ",
        "5oVNBeEEQvYi1cX3ir8Dx5n1P7pdxydbGF2X4TxVusJm": "SCNSOL",
        "4dmKkXNHdgYsXqBHCuMikNQWwVomZURhYvkkX5c4pQ7y": "SNY",
        "7i5KKsX2weiTkry7jA4ZwSuXGhs5eJBEjY8vVxR4pfRx": "GMT",
        "5PmpMzWjraf3kSsGEKtqdUsCoLhptg4yriZ17LKKdBBy": "HDG",
        SLRSSpSLUTP7okbCUBYStWCo1vUgyt775faPqz8HUMr: "SLRS",
        dK83wTVypEpa1pqiBbHY3MNuUnT3ADUZM4wk9VZXZEc: "AAVE",
        HtKKipqmgxMQJUob9XCgZBG6zSCZx4nA433ZfDuLyUTg: "ALGO",
        ATLASXmbPQxBUYbxPsV97usA3fPQYEqzQBUHgiFCUsXx: "ATLAS",
        KgV1GvrHQmRBY8sHQQeUKwTm2r2h8t4C8qt12Cw1HVE: "AVAX",
        "9gP2kCy3wA1ctvYWQk75guqXuHfrEomqydHLtcTCqiLa": "BNB",
        FtgGSFADXBtroxq8VCausXRr2of47QBf5AS1NtZCu4GD: "BRZ",
        C98A4nkJXhpVZNAZdHUA95RpTF3T4whtQubL3YobiUX9: "C98",
        "4tfNrjsyMR35Jbvua7RM2n2zsrvWBfPsuqovGxcL2DHB": "DOT",
        EchesyfXePKdLtoiZSL8pBe8Myagyy8ZRqsACNCFGnvp: "FIDA",
        EsPKhGTMf3bGoy4Qm7pCv3UCcWqAmbC1UGHBTDxRjjD4: "FTM",
        GFX1ZjR2P15tmrSwow6FjyDYcEkoFb4p4gJCpLBjaxHD: "GOFX",
        DJafV9qemGp7mLMEn5wrfqaFwxsbLgUsGVS16zKRk9kc: "HXRO",
        JET6zMJWkCN9tpRT2v2jfAmm5VnQFDpUBCyaKojmGtz: "JET",
        Gz7VkD4MacbEB6yC5XD3HcumEiYx2EtDYYrfikGsvopG: "MATIC",
        MERt85fc5boKw3BW1eYdxonEuJNvXbiMbs6hvheau5K: "MER",
        BYPsjxa3YuZESQz1dKuBw1QSFCSpecsm8nCQhY5xbU1Z: "NEAR",
        orcaEKTdK7LKz57vaAYr9QeNsVEPfiu6QeMU1kektZE: "ORCA",
        PoRTjZMPXb9T7dyU7tpLEZRQj7e6ssfAE62j2oQuc6y: "PORT",
        Saber2gLauYim4Mvftnrasomsv6NvAuncvMEZwcLpD1: "SBR",
        SLNDpmoWTVADgEdndyvWzroNL7zSi1dF9PC3xHGtPwp: "SLND",
        zebeczgi5fSEtbpfQKVZKCJ3WgYXxjkMUkNNx7fLKAF: "ZBC",
        USDH1SM1ojwWUga67PGrgFWUHibbjqMvuMaDkRJTgkX: "USDH",
        "9iLH8T7zoWhY7sBmj1WK9ENbWdS1nL8n9wAxaeRitTa6": "USH",
        HBB111SCo9jkCejsZfz8Ec8nH7T6THF8KEKSnvwT6XK6: "HBB",
        ratioMVg27rSZbSvBopUvsdrGUzeALUfFma61mpxc8J: "RATIO",
        // SOLEND COLLATERAL TOKENS
        "4icXEpFVMrcqob6fnd3jZ6KjKrc6cqre6do1f8kKAC1u": "SOLEND_CMSOL_SOL",
        A38TjtcYrfutXT6nfRxhqwoGiXyzwJsGPmekoZYYmfgP: "SOLEND_CSOFTT",
        "993dVFL2uXWYeoXuEBFXR4BijeXdTv4s6BzsCjJZuwqk": "SOLEND_CUSDC",
        "6XrbsKScacEwpEW5DVNko9t5vW3cim9wktAeT9mmiYHS": "SOLEND_CUSDCT_USDC",
        nZtL8HKX3aQtk3VpdvtdwPpXF2uMia522Pnan2meqdf: "SOLEND_CUST",
        BsWLxf6hRJnyytKR52kKBiz7qU7BB3SH77mrBxNnYU1G: "SOLEND_CMER",
        "3JFC4cB56Er45nWVe29Bhnn5GnwQzSmHVf6eUq9ac91h": "SOLEND_CMSOL",
        Gqu3TFmJXfnfSX84kqbZ5u9JjSBVoesaHjfTsaPjRSnZ: "SOLEND_CBTC",
        FbKvdbx5h6F86h1pZuEqv7FxwmsVhJ88cDuSqHvLm6Xf: "SOLEND_CETH",
        BTsbZDV7aCMRJ3VNy9ygV4Q2UeEo9GpR8D6VvmMZzNr8: "SOLEND_CUSDT",
        DiMx1n2dJmxqFtENRPhYWsqi8Mhg2p39MpTzsm6phzMP: "SOLEND_CFTT",
        AFq1sSdevxfqWGcmcz7XpPbfjHevcJY7baZf9RkyrzoR: "SOLEND_CSCNSOL",
        "5h6ssFpeDeRbzsEHDbTQNH7nVGgsKrZydxdSTnLm6QdV": "SOLEND_CSOL",
        QQ6WK86aUCBvNPkGeYBKikk15sUg6aMUEi5PTL6eB4i: "SOLEND_CSTSOL",
        AppJPZka33cu4DyUenFe9Dc1ZmZ3oQju6mBn9k37bNAa: "SOLEND_CSOETH",
        "2d95ZC8L5XP6xCnaKx8D5U5eX6rKbboBBAwuBLxaFmmJ": "SOLEND_CRAY",
        Bpm2aBL57uqVhgxutfRVrbtnjDpZLV8PZrRrytV1LgeT: "SOLEND_CSBR",
        E9LAZYxBVhJr9Cdfi9Tn4GSiJHDWSZDsew5tfgJja6Cu: "SOLEND_CORCA",
        D3Cu5urZJhkKyNZQQq2ne6xSfzbXLU4RrywVErMA2vf8: "SOLEND_CSLND",
        "4CxGuD2NMr6zM8f18gr6kRhgd748pnmkAhkY1YJtkup1": "SOLEND_CSRM",
    },
};
exports.UNDERLYINGS_TO_PUBKEY_MAP = {
    localnet: {
        MOCK_SRM: "A8WuCNG5jchCkSgPqKqEZRY7wCRn9D2qHnmeQZkxbt9u",
        MOCK_SOL: "CV3KAMGe3Q8hQLEEYMJ1aJjmxDyagpVh6Gsvf2DL5URj",
        MOCK_USDC: "5AwSyq84wsaiRyYVBdqvSvxP1zeM1sfara3ZVEAjZFB8",
        MOCK_CUSDC: "WCuh85EGUrW1qCv6C8FximNUwjfaaAqRwESHX7cBWY7",
    },
    devnet: {
        MOCK_SRM: "A8WuCNG5jchCkSgPqKqEZRY7wCRn9D2qHnmeQZkxbt9u",
        MOCK_SOL: "CV3KAMGe3Q8hQLEEYMJ1aJjmxDyagpVh6Gsvf2DL5URj",
        MOCK_USDC: "5AwSyq84wsaiRyYVBdqvSvxP1zeM1sfara3ZVEAjZFB8",
        USDC: "4zMMC9srt5Ri5X14GAgXhaHii3GnPAEERYPJgZJDncDU",
        SOL: "So11111111111111111111111111111111111111112",
        Z_MOCK_CSUDC: "WCuh85EGUrW1qCv6C8FximNUwjfaaAqRwESHX7cBWY7",
        // SOLEND COLLATERAL TOKENS
        SOLEND_CSOL: "FzwZWRMc3GCqjSrcpVX3ueJc6UpcV6iWWb7ZMsTXE3Gf",
        SOLEND_CUSDC: "E2PSSXsXJGdpqhhaV3rYPpuy1inRCQAWxcdykA1DTmYr",
        SOLEND_CRAY: "C2JUrHN3Jj4CzL1behQ8mHmswBvYGy9UcjNvvCCmEdVT",
        SOLEND_CSRM: "GVje4h3Sy8mFZgEAdpacZLq7jRLczkU9HcuAZSr6f9YM",
        SOLEND_CMSOL: "Ei2dC7hFxBhVq5pn4qNJLMxKBSojx7p7wnNoBz4HELKG",
        SOLEND_CUSDT: "ACo8zUxnXNaTvjvN5S56C7KLWzCH4pXjSMU7iAg6dHj8",
        SOLEND_CSOFTT: "6G9TFs48EkWQodGHAK1fjXC8umqZBdn8Mc8bX5iUvc2j",
        SOLEND_CMER: "66F7DZxwKB4KpPy3xFMzRRzh2pLHhJ7qegBM3ejFAwg4",
        SOLEND_CSOETH: "3kqx7NHrBWUD6LuWvvwzocpTVt7TDYbJ3ad7HNUPSBf6",
        SOLEND_CSBR: "4GAGuewTRMfBJukgu3HSzpT48iqP4bYVCq3tygnjqmxL",
        SOLEND_CBTC: "7YaBJi5jnuadi5LZBB9NgRt1hPKhA7qQYWkzU11kgRcn",
    },
    mainnet: {
        SOL: "So11111111111111111111111111111111111111112",
        USDC: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
        USDT: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
        MSOL: "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So",
        STSOL: "7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj",
        SRM: "SRMuApVNdxXokk5GT7XD5cUUgXMBCoAz2LHeuAoKWRt",
        ETH: "2FPyTwcZLUg1MDrwsyoP4D6s1tM7hAkHYRjkNb5w6Pxk",
        ETHPO: "7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs",
        BTC: "9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E",
        LUNA: "F6v4wfAdJB8D8p77bMXZgYt8TDKsYxLYxH5AFhUkYx9W",
        MNGO: "MangoCzJ36AjZyKwVj3VnYU4GTonjfVEnJmvvWaxLac",
        FTT: "AGFEad2et2ZJif9jaGpdMixQqvW5i81aBdvKe7PHNfz3",
        RAY: "4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R",
        WINJ: "Hgtvu9gsDTzUpBn69WjrhMyzaQhrAM9piTsezmZVQP6Z",
        SCNSOL: "5oVNBeEEQvYi1cX3ir8Dx5n1P7pdxydbGF2X4TxVusJm",
        SNY: "4dmKkXNHdgYsXqBHCuMikNQWwVomZURhYvkkX5c4pQ7y",
        GMT: "7i5KKsX2weiTkry7jA4ZwSuXGhs5eJBEjY8vVxR4pfRx",
        HDG: "5PmpMzWjraf3kSsGEKtqdUsCoLhptg4yriZ17LKKdBBy",
        SLRS: "SLRSSpSLUTP7okbCUBYStWCo1vUgyt775faPqz8HUMr",
        AAVE: "dK83wTVypEpa1pqiBbHY3MNuUnT3ADUZM4wk9VZXZEc",
        ALGO: "HtKKipqmgxMQJUob9XCgZBG6zSCZx4nA433ZfDuLyUTg",
        ATLAS: "ATLASXmbPQxBUYbxPsV97usA3fPQYEqzQBUHgiFCUsXx",
        AVAX: "KgV1GvrHQmRBY8sHQQeUKwTm2r2h8t4C8qt12Cw1HVE",
        BNB: "9gP2kCy3wA1ctvYWQk75guqXuHfrEomqydHLtcTCqiLa",
        BRZ: "FtgGSFADXBtroxq8VCausXRr2of47QBf5AS1NtZCu4GD",
        C98: "C98A4nkJXhpVZNAZdHUA95RpTF3T4whtQubL3YobiUX9",
        DOT: "4tfNrjsyMR35Jbvua7RM2n2zsrvWBfPsuqovGxcL2DHB",
        FIDA: "EchesyfXePKdLtoiZSL8pBe8Myagyy8ZRqsACNCFGnvp",
        FTM: "EsPKhGTMf3bGoy4Qm7pCv3UCcWqAmbC1UGHBTDxRjjD4",
        GOFX: "GFX1ZjR2P15tmrSwow6FjyDYcEkoFb4p4gJCpLBjaxHD",
        HXRO: "DJafV9qemGp7mLMEn5wrfqaFwxsbLgUsGVS16zKRk9kc",
        JET: "JET6zMJWkCN9tpRT2v2jfAmm5VnQFDpUBCyaKojmGtz",
        MATIC: "Gz7VkD4MacbEB6yC5XD3HcumEiYx2EtDYYrfikGsvopG",
        MER: "MERt85fc5boKw3BW1eYdxonEuJNvXbiMbs6hvheau5K",
        NEAR: "BYPsjxa3YuZESQz1dKuBw1QSFCSpecsm8nCQhY5xbU1Z",
        ORCA: "orcaEKTdK7LKz57vaAYr9QeNsVEPfiu6QeMU1kektZE",
        PORT: "PoRTjZMPXb9T7dyU7tpLEZRQj7e6ssfAE62j2oQuc6y",
        SBR: "Saber2gLauYim4Mvftnrasomsv6NvAuncvMEZwcLpD1",
        SLND: "SLNDpmoWTVADgEdndyvWzroNL7zSi1dF9PC3xHGtPwp",
        ZBC: "zebeczgi5fSEtbpfQKVZKCJ3WgYXxjkMUkNNx7fLKAF",
        USDH: "USDH1SM1ojwWUga67PGrgFWUHibbjqMvuMaDkRJTgkX",
        USH: "9iLH8T7zoWhY7sBmj1WK9ENbWdS1nL8n9wAxaeRitTa6",
        HBB: "HBB111SCo9jkCejsZfz8Ec8nH7T6THF8KEKSnvwT6XK6",
        // SOLEND COLLATERAL TOKENS
        SOLEND_CMSOL_SOL: "4icXEpFVMrcqob6fnd3jZ6KjKrc6cqre6do1f8kKAC1u",
        SOLEND_CSOFTT: "A38TjtcYrfutXT6nfRxhqwoGiXyzwJsGPmekoZYYmfgP",
        SOLEND_CUSDC: "993dVFL2uXWYeoXuEBFXR4BijeXdTv4s6BzsCjJZuwqk",
        SOLEND_CUSDCT_USDC: "6XrbsKScacEwpEW5DVNko9t5vW3cim9wktAeT9mmiYHS",
        SOLEND_CUST: "nZtL8HKX3aQtk3VpdvtdwPpXF2uMia522Pnan2meqdf",
        SOLEND_CMER: "BsWLxf6hRJnyytKR52kKBiz7qU7BB3SH77mrBxNnYU1G",
        SOLEND_CMSOL: "3JFC4cB56Er45nWVe29Bhnn5GnwQzSmHVf6eUq9ac91h",
        SOLEND_CBTC: "Gqu3TFmJXfnfSX84kqbZ5u9JjSBVoesaHjfTsaPjRSnZ",
        SOLEND_CETH: "FbKvdbx5h6F86h1pZuEqv7FxwmsVhJ88cDuSqHvLm6Xf",
        SOLEND_CUSDT: "BTsbZDV7aCMRJ3VNy9ygV4Q2UeEo9GpR8D6VvmMZzNr8",
        SOLEND_CFTT: "DiMx1n2dJmxqFtENRPhYWsqi8Mhg2p39MpTzsm6phzMP",
        SOLEND_CSCNSOL: "AFq1sSdevxfqWGcmcz7XpPbfjHevcJY7baZf9RkyrzoR",
        SOLEND_CSOL: "5h6ssFpeDeRbzsEHDbTQNH7nVGgsKrZydxdSTnLm6QdV",
        SOLEND_CSTSOL: "QQ6WK86aUCBvNPkGeYBKikk15sUg6aMUEi5PTL6eB4i",
        SOLEND_CSOETH: "AppJPZka33cu4DyUenFe9Dc1ZmZ3oQju6mBn9k37bNAa",
        SOLEND_CRAY: "2d95ZC8L5XP6xCnaKx8D5U5eX6rKbboBBAwuBLxaFmmJ",
        SOLEND_CSBR: "Bpm2aBL57uqVhgxutfRVrbtnjDpZLV8PZrRrytV1LgeT",
        SOLEND_CORCA: "E9LAZYxBVhJr9Cdfi9Tn4GSiJHDWSZDsew5tfgJja6Cu",
        SOLEND_CSLND: "D3Cu5urZJhkKyNZQQq2ne6xSfzbXLU4RrywVErMA2vf8",
        SOLEND_CSRM: "4CxGuD2NMr6zM8f18gr6kRhgd748pnmkAhkY1YJtkup1",
    },
};
